import { Input } from '@/components/ui/input'
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select'
import type { WorkshopLocation } from '@backend/schemas'
import { useEffect, useState } from 'react'

// Mirrors the backend WorkshopLocation enum, which the web can only import as a type
export const WORKSHOPS = [
  'bromma',
  'enköping',
  'göteborg',
  'linköping',
  'mantorp',
  'täby',
  'örebro',
] as const satisfies readonly `${WorkshopLocation}`[]

interface ListSearchInputProps {
  value: string
  placeholder: string
  onChange: (value: string) => void
}

// Keeps typing local and only reports after a pause, so each keystroke doesn't trigger a query
export const ListSearchInput = ({ value, placeholder, onChange }: ListSearchInputProps) => {
  const [text, setText] = useState(value)

  useEffect(() => setText(value), [value])

  useEffect(() => {
    if (text === value) return
    const timeout = setTimeout(() => onChange(text.trim()), 300)
    return () => clearTimeout(timeout)
  }, [text]) // eslint-disable-line react-hooks/exhaustive-deps

  return <Input placeholder={placeholder} value={text} onChange={e => setText(e.target.value)} className="max-w-sm" />
}

interface WorkshopSelectProps {
  value: string
  onChange: (value: string) => void
}

export const WorkshopSelect = ({ value, onChange }: WorkshopSelectProps) => (
  <Select value={value || 'all'} onValueChange={next => onChange(next === 'all' ? '' : next)}>
    <SelectTrigger className="max-w-[200px]">
      <SelectValue placeholder="Välj verkstad" />
    </SelectTrigger>
    <SelectContent>
      <SelectItem value="all">Alla verkstäder</SelectItem>
      {WORKSHOPS.map(workshop => (
        <SelectItem key={workshop} className="capitalize" value={workshop}>
          {workshop}
        </SelectItem>
      ))}
    </SelectContent>
  </Select>
)
